import { userAtom } from '@/global-state'
import { getStore } from '@/store'
import { canPerformQrActions } from '@/utils/user/userPermissions'

import { subExpiredDialogAtom } from '../../../../dialogs/dialogStates'

export const withExpiredDialogIfNotAllowed = <
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	T extends (...args: any[]) => any,
>(
	callback: T,
	onBeforeOpenDialog?: () => void,
): T => {
	const user = getStore().get(userAtom)
	const isAllowed = canPerformQrActions(user)
	if (!isAllowed) {
		return (() => {
			onBeforeOpenDialog?.()
			getStore().set(subExpiredDialogAtom, true)
			return
		}) as T
	}
	return callback
}
